import { Component, EventEmitter, OnInit } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

interface AddressInterface {
    line1: string;
    location: string;
}
interface AgentInterface {
    image: string;
    name: {long: string};
    phone: string;
    email: string;
}

@Component({
  selector: 'front-page',
  templateUrl: './front.component.html',
  styleUrls: ['./front.component.scss'],
  outputs: ['loading']
})
export class FrontComponent implements OnInit {
    private loading: EventEmitter<any>;
    private showAgentList: boolean = false;
    private list: any;
    private agents: any;
    private price: string;
    private tag: string;
    private mls: number;
    private address: AddressInterface;
    private items: Array<string> = new Array();
    private remarks: string;
    private agent: AgentInterface;

    public constructor(private http: Http, private route: ActivatedRoute) {
        this.loading = new EventEmitter<any>();
    }

    public ngOnInit() {
        this.loading.emit({
            loading: true,
            error: ''
        });
        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);
        let error = '';
        this.http.get(environment.endpoint + '/load/' + this.route.snapshot.params['id'], {headers: headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                    if(res.status === 'OK') {
                        this.price = res.results.price;
                        this.tag = res.results.tag;
                        this.mls = res.results.mls;
                        this.address = res.results.address;
                        this.remarks = res.results.remarks;
                        this.list = res.results.list;
                        for(let agent in this.agents) {
                            if(this.agents[agent].id === res.results.agent) {
                                this.agent = this.agents[agent];
                            }
                        }
                    } else {
                        error = 'Can\'t load flyer';
                    }
                     this.loading.emit({
                         loading: false,
                         error: error
                     });
                },
                err => { console.log(err); this.loading.emit({
                    loading: false,
                    error: err
                }); }
            );
        this.loadAgentList();
    }
    private loadAgentList(): void {

        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);

        this.http.get(environment.endpoint + '/load/agents', {headers: headers})
            .map(res => res.json())
            .subscribe(
                res => {
                    if(res.status === 'OK') {
                        this.agents = res.results;
                    } else {
                        alert(res.results);
                    }
                },
                err => {
                    alert(err);
                }
            );
    }
    private openAgentChooser(): void {
        this.showAgentList = !this.showAgentList;
    }
    private chooseAgent(agent: any): void {
        this.showAgentList = !this.showAgentList;
        this.agent = agent;
        this.openAgentChooser();

        let token = localStorage.getItem('amt_flyer_token');
        let headers = new Headers();
        headers.append('Authorization', token);

        this.http.post(environment.endpoint+'/update/' + this.route.snapshot.params['id'], {key: 'agent', value: agent.id}, {headers: headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                    if(res.status != 'OK')
                        alert(res.results);
                },
                err => { console.log(err); }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/front/front.component.ts